module.exports = __webpack_public_path__ + "static/media/visuel05.de53bc8e.jpg";